import React, { useState, useEffect, useRef } from 'react';
import './Refonte-de-Site-Web.css';
import Header from '../Header/Header';
import Footer from '../footer/footer';
import { motion, AnimatePresence } from 'framer-motion';
import TopAnnouncementBar from '../TopAnnouncementBar/TopAnnouncementBar';
import WhatsAppButton from '../whatsapp/WhatsAppButton';
import { Link } from 'react-router-dom';
import { 
  FaRocket, 
  FaMobileAlt, 
  FaSearch, 
  FaShieldAlt,
  FaChartLine,
  FaSyncAlt,
  FaLaptopCode,
  FaUsers,
  FaShoppingCart,
  FaArrowRight,
  FaCheckCircle,
  FaAward,
  FaClock,
  FaCode,
  FaTachometerAlt,
  FaRegEye,
  FaPalette,
  FaDatabase,
  FaCloud
} from 'react-icons/fa';
import { 
  SiGoogle,
  SiWebpack,
  SiReact,
  SiWordpress
} from 'react-icons/si';
import { MdAutoAwesome, MdOutlineSpeed, MdOutlineSecurity, MdOutlineSupportAgent, MdAnalytics, MdDesignServices, MdIntegrationInstructions } from 'react-icons/md';
import { GiAstronautHelmet, GiStarsStack, GiGalaxy, GiSpiralShell, GiCrystalBall, GiCyberEye, GiArtificialIntelligence, GiThunderSkull, GiBrain, GiRocketThruster, GiUpgrade, GiRecycle } from 'react-icons/gi';

const RefonteSiteWeb = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isCursorActive, setIsCursorActive] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const sectionRef = useRef(null);
  let cursorTimeout;

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
      setIsCursorActive(true);
      
      clearTimeout(cursorTimeout);
      cursorTimeout = setTimeout(() => setIsCursorActive(false), 100);
    };
    
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        const scrollPercent = Math.min(1, Math.max(0, -rect.top / (rect.height - window.innerHeight)));
        setScrollProgress(scrollPercent);
      }
    };
    
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(cursorTimeout);
    };
  }, []);

  const solutionsData = [
    {
      title: "Refonte Complète",
      tagline: "Transformation totale",
      description: "Transformation totale de votre site avec une nouvelle identité visuelle et une architecture modernisée pour des performances optimales.",
      features: ["Audit approfondi", "Nouveau design UX/UI", "Migration sécurisée", "Optimisation technique"],
      icon: <GiUpgrade />,
      color: "#3B82F6",
      stat: "+300% de performances"
    },
    {
      title: "Optimisation Technique",
      tagline: "Performances accrues",
      description: "Amélioration des performances, sécurité et référencement sans changer le design pour un site plus rapide et plus sûr.",
      features: ["Optimisation des performances", "Mise à jour des technologies", "Renforcement sécurité", "SEO technique"],
      icon: <MdOutlineSpeed />,
      color: "#10B981",
      stat: "-70% de temps de chargement"
    },
    {
      title: "Modernisation Design",
      tagline: "Design contemporain",
      description: "Mise à jour de l'interface utilisateur pour une expérience moderne et engageante qui capte l'attention.",
      features: ["Redesign UI/UX", "Adaptation responsive", "Nouvelle charte graphique", "Prototypage interactif"],
      icon: <FaPalette />,
      color: "#8B5CF6",
      stat: "+80% d'engagement"
    },
    {
      title: "Migration de CMS",
      tagline: "Flexibilité accrue",
      description: "Passage à un nouveau système de gestion de contenu plus performant et flexible pour une meilleure autonomie.",
      features: ["Audit des besoins", "Choix du nouveau CMS", "Migration des contenus", "Formation à l'administration"],
      icon: <FaDatabase />,
      color: "#F59E0B",
      stat: "100% de données préservées"
    },
    {
      title: "Refonte E-commerce",
      tagline: "Conversion maximale",
      description: "Modernisation de votre boutique en ligne pour augmenter vos conversions et fidéliser vos clients.",
      features: ["Redesign du catalogue", "Optimisation tunnel d'achat", "Intégration de paiements", "Analytics avancés"],
      icon: <FaShoppingCart />,
      color: "#EC4899",
      stat: "+45% de conversions"
    }
  ];

  const benefits = [
    { icon: <FaChartLine />, title: "Boost des performances", description: "Temps de chargement optimisés", color: "#3B82F6" },
    { icon: <FaMobileAlt />, title: "Mobile First", description: "Adaptation parfaite à tous les écrans", color: "#10B981" },
    { icon: <FaSearch />, title: "SEO amélioré", description: "Meilleur référencement naturel", color: "#8B5CF6" },
    { icon: <FaShieldAlt />, title: "Sécurité renforcée", description: "Protection contre les menaces", color: "#F59E0B" },
    { icon: <FaSyncAlt />, title: "Technologies modernes", description: "Solutions évolutives", color: "#EC4899" },
    { icon: <FaUsers />, title: "Expérience utilisateur", description: "Navigation intuitive", color: "#06B6D4" }
  ];

  const statsData = [
    { value: "+300%", label: "performance", icon: <FaTachometerAlt /> },
    { value: "+45%", label: "conversions", icon: <FaChartLine /> },
    { value: "100%", label: "sécurisé", icon: <FaShieldAlt /> },
    { value: "SEO", label: "optimisé", icon: <FaSearch /> }
  ];

  const technologies = [
    { icon: <SiReact />, name: "React/Next.js", color: "#61DAFB" },
    { icon: <SiWordpress />, name: "WordPress", color: "#21759B" },
    { icon: <SiWebpack />, name: "Webpack", color: "#8DD6F9" },
    { icon: <SiGoogle />, name: "Google Analytics", color: "#F9AB00" },
    { icon: <FaCloud />, name: "Cloud Hosting", color: "#3B82F6" },
    { icon: <MdIntegrationInstructions />, name: "API", color: "#10B981" }
  ];

  const getPreviewBadgeText = () => {
    switch(activeTab) {
      case 0: return "Transformation complète";
      case 1: return "Performance garantie";
      case 2: return "Design moderne";
      case 3: return "Migration fluide";
      case 4: return "E-commerce boosté";
      default: return "Solution refonte";
    }
  };

  return (
    <div className="rw-container" ref={sectionRef}>
      <WhatsAppButton />
      <TopAnnouncementBar />
      <Header />
      
      {/* Cursor Glow */}
      <motion.div 
        className={`rw-cursor-glow ${isCursorActive ? 'active' : ''}`}
        animate={{
          x: mousePosition.x - 300,
          y: mousePosition.y - 300,
        }}
        transition={{ type: "spring", damping: 30, stiffness: 200, mass: 0.5 }}
      />

      {/* Particles */}
      <div className="rw-particles">
        {[...Array(60)].map((_, i) => (
          <div key={i} className="rw-particle" style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 20}s`,
            animationDuration: `${20 + Math.random() * 30}s`,
            width: `${1.5 + Math.random() * 3}px`,
            height: `${1.5 + Math.random() * 3}px`,
          }} />
        ))}
      </div>

      {/* Animated Orbs */}
      <div className="rw-orbs">
        <div className="rw-orb rw-orb-1" style={{ transform: `translate(${scrollProgress * 100}px, ${scrollProgress * 50}px)` }} />
        <div className="rw-orb rw-orb-2" style={{ transform: `translate(-${scrollProgress * 80}px, -${scrollProgress * 60}px)` }} />
        <div className="rw-orb rw-orb-3" style={{ transform: `translate(${scrollProgress * 60}px, -${scrollProgress * 40}px)` }} />
        <div className="rw-orb rw-orb-4" style={{ transform: `translate(-${scrollProgress * 70}px, ${scrollProgress * 70}px)` }} />
      </div>

      {/* Floating Elements */}
      <div className="rw-floating">
        <GiGalaxy className="rw-float rw-float-1" />
        <GiSpiralShell className="rw-float rw-float-2" />
        <GiAstronautHelmet className="rw-float rw-float-3" />
        <GiStarsStack className="rw-float rw-float-4" />
        <GiCrystalBall className="rw-float rw-float-5" />
        <GiCyberEye className="rw-float rw-float-6" />
        <GiArtificialIntelligence className="rw-float rw-float-7" />
        <GiThunderSkull className="rw-float rw-float-8" />
        <GiBrain className="rw-float rw-float-9" />
        <GiRocketThruster className="rw-float rw-float-10" />
        <GiRecycle className="rw-float rw-float-11" />
      </div>
      
      {/* ========== HERO BANNER ========== */}
      <section className="rw-hero">
        <div className="rw-hero-overlay"></div>
        <div className="rw-hero-inner">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="rw-hero-badge"
          >
            <GiRecycle />
            <span>Refonte Web Excellence</span>
            <GiStarsStack />
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="rw-hero-title"
          >
            Refonte de site web<br />
            <span className="rw-gradient-text">sur mesure</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="rw-hero-subtitle"
          >
            Modernisez votre présence en ligne avec une refonte stratégique qui booste vos performances,
            votre image et vos conversions.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="rw-hero-buttons"
          >
            <Link to="/reservation-appel">
              <button className="rw-btn rw-btn-primary">
                <MdAutoAwesome /> Démarrer mon projet <FaArrowRight />
              </button>
            </Link>
            <Link to="/realisations">
              <button className="rw-btn rw-btn-secondary">
                <FaCode /> Voir nos réalisations
              </button>
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="rw-hero-stats"
          >
            {statsData.map((stat, idx) => (
              <div key={idx} className="rw-stat-card">
                <div className="rw-stat-icon">{stat.icon}</div>
                <div className="rw-stat-value">{stat.value}</div>
                <div className="rw-stat-label">{stat.label}</div>
              </div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* ========== BENEFITS SECTION ========== */}
      <section className="rw-benefits">
        <div className="rw-container-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="rw-section-header"
          >
            <div className="rw-badge">Pourquoi refondre ?</div>
            <h2>Les bénéfices <span className="rw-gradient-text">d'une refonte</span></h2>
            <p>Une refonte bien menée peut transformer radicalement vos résultats en ligne</p>
          </motion.div>

          <div className="rw-benefits-grid">
            {benefits.map((benefit, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.05 }}
                whileHover={{ y: -8 }}
                className="rw-benefit-card"
                style={{ '--rw-card-color': benefit.color }}
              >
                <div className="rw-benefit-icon" style={{ color: benefit.color }}>{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
                <div className="rw-benefit-glow" style={{ background: `radial-gradient(circle, ${benefit.color}20, transparent)` }} />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ========== SOLUTIONS SECTION - TABS ========== */}
      <section className="rw-solutions">
        <div className="rw-container-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="rw-section-header"
          >
            <div className="rw-badge">Nos services</div>
            <h2>Services de <span className="rw-gradient-text">refonte web</span></h2>
            <p>Des solutions adaptées à chaque besoin de modernisation</p>
          </motion.div>

          {/* Tabs navigation */}
          <div className="rw-tabs-nav">
            {solutionsData.map((sol, idx) => (
              <button
                key={idx}
                className={`rw-tab-btn ${activeTab === idx ? 'active' : ''}`}
                onClick={() => setActiveTab(idx)}
                style={{ '--rw-tab-color': sol.color }}
              >
                <span className="rw-tab-icon">{sol.icon}</span>
                <span className="rw-tab-title">{sol.title}</span>
              </button>
            ))}
          </div>

          {/* Tab content */}
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.4 }}
              className="rw-tab-content"
            >
              <div className="rw-tab-left">
                <div className="rw-solution-tagline" style={{ color: solutionsData[activeTab].color }}>
                  {solutionsData[activeTab].tagline}
                </div>
                <h3>{solutionsData[activeTab].title}</h3>
                <p>{solutionsData[activeTab].description}</p>
                <div className="rw-features-list">
                  {solutionsData[activeTab].features.map((feat, i) => (
                    <div key={i} className="rw-feature-item">
                      <FaCheckCircle style={{ color: solutionsData[activeTab].color }} />
                      <span>{feat}</span>
                    </div>
                  ))}
                </div>
                <div className="rw-solution-stat" style={{ background: `${solutionsData[activeTab].color}15`, borderLeftColor: solutionsData[activeTab].color }}>
                  <FaRocket />
                  <span><strong>{solutionsData[activeTab].stat}</strong></span>
                </div>
              </div>
              <div className="rw-tab-right">
                <div className="rw-preview-card" style={{ background: `linear-gradient(135deg, ${solutionsData[activeTab].color}10, rgba(10,17,40,0.4))` }}>
                  <div className="rw-preview-icon" style={{ color: solutionsData[activeTab].color }}>
                    {solutionsData[activeTab].icon}
                  </div>
                  <div className="rw-preview-badge">
                    {getPreviewBadgeText()}
                  </div>
                  <div className="rw-preview-stats">
                    <span>⚡ Performance</span>
                    <span>🔒 Sécurisé</span>
                    <span>📱 Responsive</span>
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </section>

      {/* ========== PROCESS SECTION ========== */}
      <section className="rw-process">
        <div className="rw-container-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="rw-section-header"
          >
            <div className="rw-badge">Notre méthode</div>
            <h2>Méthodologie <span className="rw-gradient-text">de refonte</span></h2>
            <p>Une approche structurée pour des résultats optimaux</p>
          </motion.div>

          <div className="rw-process-steps">
            {[
              { step: "01", title: "Audit & Analyse", desc: "Évaluation complète et définition des objectifs", icon: <FaSearch />, color: "#3B82F6" },
              { step: "02", title: "Stratégie", desc: "Plan d'action personnalisé avec roadmap", icon: <FaChartLine />, color: "#8B5CF6" },
              { step: "03", title: "Conception", desc: "Design UX/UI moderne et prototypage", icon: <FaLaptopCode />, color: "#10B981" },
              { step: "04", title: "Développement", desc: "Implémentation avec les meilleures pratiques", icon: <FaCode />, color: "#F59E0B" },
              { step: "05", title: "Tests & Optimisation", desc: "Validation complète avant production", icon: <FaShieldAlt />, color: "#EC4899" },
              { step: "06", title: "Mise en ligne", desc: "Migration sécurisée et suivi post-lancement", icon: <FaSyncAlt />, color: "#06B6D4" }
            ].map((step, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.05 }}
                whileHover={{ y: -5 }}
                className="rw-process-step"
              >
                <div className="rw-step-number" style={{ backgroundColor: step.color }}>{step.step}</div>
                <div className="rw-step-icon" style={{ color: step.color }}>{step.icon}</div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ========== TECHNOLOGIES SECTION ========== */}
      <section className="rw-tech">
        <div className="rw-container-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="rw-section-header"
          >
            <div className="rw-badge">Stack technique</div>
            <h2>Technologies <span className="rw-gradient-text">modernes</span></h2>
            <p>Nous utilisons les meilleures technologies pour votre refonte</p>
          </motion.div>

          <div className="rw-tech-grid">
            {technologies.map((tech, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.05 }}
                whileHover={{ y: -5 }}
                className="rw-tech-card"
              >
                <div className="rw-tech-icon" style={{ color: tech.color }}>{tech.icon}</div>
                <h4>{tech.name}</h4>
                <div className="rw-tech-bar">
                  <div className="rw-tech-progress" style={{ backgroundColor: tech.color }} />
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ========== FINAL CTA ========== */}
      <section className="rw-final-cta">
        <div className="rw-cta-pattern"></div>
        <div className="rw-cta-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="rw-cta-icon"
          >
            <GiRocketThruster />
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Prêt à <span className="rw-gradient-text">moderniser</span> votre site web ?
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Contactez-nous pour un audit gratuit de votre site actuel.
          </motion.p>
          <Link to="/reservation-appel">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              className="rw-cta-button"
            >
              <MdAutoAwesome /> Demander un audit gratuit <FaArrowRight />
            </motion.button>
          </Link>
          <div className="rw-cta-features">
            <div><FaCheckCircle /> Réponse sous 24h</div>
            <div><FaShieldAlt /> Garantie satisfait</div>
            <div><FaUsers /> Support dédié</div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default RefonteSiteWeb;